var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgCalenderClock(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    clipPath: "url(#clip0_2140_35665)"
  }, /*#__PURE__*/React.createElement("path", {
    d: "M4.99992 9.16658C7.30111 9.16658 9.16658 7.30111 9.16658 4.99992C9.16658 2.69873 7.30111 0.833252 4.99992 0.833252C2.69873 0.833252 0.833252 2.69873 0.833252 4.99992C0.833252 7.30111 2.69873 9.16658 4.99992 9.16658Z",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }), /*#__PURE__*/React.createElement("path", {
    d: "M5 2.5V5L6.66667 5.83333",
    stroke: "#1A1A1A",
    strokeLinecap: "round",
    strokeLinejoin: "round"
  }))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_2140_35665"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 10,
    height: 10,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalenderClock);
export default __webpack_public_path__ + "static/media/calender-clock.d80e77ebf424694927985be991697096.svg";
export { ForwardRef as ReactComponent };